import { Component, Inject, OnDestroy, OnInit, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldDictionaryDto, IBaseService, SingleResponseModel } from 'src/app/tabms/models/base/base';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';

@Component({
  selector: 'app-base-info',
  templateUrl: './base-info.component.html',
  styleUrl: './base-info.component.scss'
})
export class BaseInfoComponent<T> implements OnInit, OnDestroy {
  fieldsConfigService;
  serviceInstance;
  viewId;
  viewData;
  dataColumns: FieldDictionaryDto[] = [];
  currentLang: string;

  private destroy$: Subject<void> = new Subject<void>();
  // constructor
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.serviceInstance = data.service;
    this.viewId = data.id;
    this.fieldsConfigService = data.fieldsConfigService;

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
      }
    })
  }

  ngOnInit(): void {
    this.fieldsConfigService.infoColumns.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.dataColumns = value.map((obj: FieldDictionaryDto) => ({
        ...obj,
        fieldname: obj.fieldname.toLowerCase(),
      }));
      console.log('infoColumnsSubject', value);
      this.getData();
    });

  }

  getData() {
    this.serviceInstance.get(this.viewId).pipe(takeUntil(this.destroy$)).subscribe((res: SingleResponseModel<T>) => {
      const data = res.result ? res.result : res;
      this.viewData = Object.keys(data).reduce((acc, key) => {
        acc[key.toLowerCase()] = data[key];
        return acc;
      }, {});
      console.log(this.viewData)
    });
    //this.dataColumns = this.fieldsConfigService.getInfoData();
  }

  getdisplayedHeaders(col: FieldDictionaryDto): string {
    const header = this.currentLang === 'ar' ?
      col.langvalue.find(x => x.culturename === 'ar-EG')?.value : col.langvalue.find(x => x.culturename === this.currentLang)?.value
    return header
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
